// @Injectable()
import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export abstract class UnsubscribeDestroyHelper implements OnDestroy {
  protected unsubscribeSubject: Subject<void> = new Subject<void>();

  public ngOnDestroy(): void {
    this.unsubscribeSubject.next();
    this.unsubscribeSubject.complete();
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/helpers/unsubscribe.helper.ts